import axios from "../../utils/axios";

export const getLikes = async (obj) => {
    console.log(obj);
    const response = await axios.patch(`/videos/${obj.id}`, {
            likes:obj.likesLocal,
        }, {
            headers: { 'Content-type': 'application/json; charset=UTF-8' }
        });

    // console.log(response);

    return  response.data;
};


